import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
// import { all_routes } from "../../../../Router/all_routes";
import { ChevronUp, RotateCcw } from "feather-icons-react/build/IconComponents";
import { setToogleHeader } from "../../../../core/redux/action";
import TicketsTable from "./TicketsTable";

const CRMTickets = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.rootReducer.toggle_header);
  //   const route = all_routes;

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="row d-flex justify-content-between">
          <div className="col-12 col-md-6 col-lg-3 d-flex ">
            <div className="card revenue-widget flex-fill border border-danger">
              <div className="card-body align-items-center d-flex row justify-content-center">
                <div className="d-flex col-12 mb-2 justify-content-start">
                  <h4 className=" me-2">67</h4>
                  <p>Open</p>
                </div>
                {/* <div className="d-flex col-12 justify-content-center">
                  <p className="me-2 mb-0">Assigned to me:</p>
                  <h4 className="">9</h4>
                </div> */}
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-3 d-flex ">
            <div className="card revenue-widget flex-fill border border-info">
              <div className="card-body align-items-center d-flex row">
                <div className="d-flex col-12 mb-2 justify-content-start">
                  <h4 className=" me-2">88</h4>
                  <p>In Progress</p>
                </div>
                {/* <div className="d-flex col-12 justify-content-center">
                  <p className="me-2 mb-0">Assigned to me:</p>
                  <h4 className="">5</h4>
                </div> */}
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-3 d-flex ">
            <div className="card revenue-widget flex-fill border border-warning">
              <div className="card-body align-items-center d-flex row">
                <div className="d-flex col-12 mb-2 justify-content-start">
                  <h4 className=" me-2">11</h4>
                  <p>Answered</p>
                </div>
                {/* <div className="d-flex col-12 justify-content-center">
                  <p className="me-2 mb-0">Assigned to me:</p>
                  <h4 className="">8</h4>
                </div> */}
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-3 d-flex ">
            <div className="card revenue-widget flex-fill border border-info">
              <div className="card-body align-items-center d-flex row">
                <div className="d-flex col-12 mb-2 justify-content-start">
                  <h4 className=" me-2">26</h4>
                  <p>Closed</p>
                </div>
                {/* <div className="d-flex col-12 justify-content-center">
                  <p className="me-2 mb-0">Assigned to me:</p>
                  <h4 className="">0</h4>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/crm/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    Tickets
                  </h4>
                </ol>
              </nav>
              <h6>Manage your Tickets here</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <OverlayTrigger placement="top" overlay={renderTooltip}>
                <Link>
                  <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <ImageWithBasePath
                    src="assets/img/icons/excel.svg"
                    alt="img"
                  />
                </Link>
              </OverlayTrigger>
            </li>

            <li>
              <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
          <div className="page-btn">
            <Link
              to="/crm/newticket"
              className="btn btn-primary"
            >
              <i className="ti ti-circle-plus me-1"></i>
              New Ticket
            </Link>
          </div>
        </div>
        {/* /product list */}
        <TicketsTable />
      </div>
    </div>
  );
};

export default CRMTickets;
